function Observer( bind_object ) {

	this.events = {
		'event.name' : [ 'handlerA' , 'handlerB' , '...' ]
	}

	this._this = bind_object || this;

}

Observer.prototype = {

	subscribe( event_name , handler ){

		if ( typeof event_name !== 'string' ) {
			throw new Error('Event name is not a string');
		}

		if ( typeof handler !== 'function' ) {
			throw new Error('Event handler is not a function');
		}

		if ( ! this.events.hasOwnProperty( event_name ) ) {
			this.events[event_name] = [];
		}

		this.events[event_name].push( handler );
	},

	unsubscribe( event_name , handler ){
		if ( typeof event_name !== 'string' ) {
			throw new Error('Event name is not a string');
		}

		if ( typeof handler !== 'function' ) {
			throw new Error('Event handler is not a function');
		}

		if ( this.events.hasOwnProperty( event_name ) ) {
			this.events[event_name] = this.events[event_name].filter( eventHandler => eventHandler !== handler );
		}
	},

	dispatch( event_name , ...args ){
		if ( typeof event_name !== 'string' ) {
			throw new Error('Event name is not a string');
		}

		if ( this.events.hasOwnProperty( event_name ) ) {
			this.events[event_name].forEach( eventHandler => eventHandler.apply( this._this , args ) );
		}
	}
};

export default Observer;
